import { render, staticRenderFns } from "./ClaimDetailDialog.vue?vue&type=template&id=dfeb5588&scoped=true&"
import script from "./ClaimDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetailDialog.vue?vue&type=style&index=0&id=dfeb5588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeb5588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VRow,VSpacer})
